import CardsList from '../components/CardsList';
import { buscarCorSLA } from '../rules/regraSLA';
import { formatarTempo, cardProtocolo, cardCategoriaPaciente } from './FormatHelpers';

/**
 * Monta as informações consolidadas dos cards para a TELA INICIAL.
 */
export const montarInfoCards = (dataDetalhada) => {
	const dados = dataDetalhada ?? {};
	const infoCards = {};
	
	CardsList.forEach((card) => {
		const dataPacientes = dados[card.tipo] ?? [];
		const pacientesAdulto = dataPacientes.filter((item) => !card.regras.isPediatria(item));
		const pacientesInfantil = dataPacientes.filter((item) => card.regras.isPediatria(item));

		// Medicação
		const pacientesDispensacao = dataPacientes.filter((item) => item.AGUARDANDO === 'Dispensação');
		const pacientesChecagem = dataPacientes.filter((item) => item.AGUARDANDO === 'Checagem');

		// Exames Laboratoriais/Imagem
		const pacientesColeta = dataPacientes.filter((item) => item.TIPO === 'COLETA');
		const pacientesLaudo = dataPacientes.filter((item) => item.TIPO === 'LAUDO');

		// Internação
		const pacientesAutorizacao = dataPacientes.filter((item) => item.SITUACAO === 'Aguardando Autorização');
		const pacientesLeitoExtra = dataPacientes.filter((item) => item.SITUACAO !== 'Aguardando Autorização');

		let arrCoresAdulto = [];
		pacientesAdulto.forEach(paciente => {
			arrCoresAdulto.push(buscarCorSLA({ tipoCard: card.tipo, tempo: (paciente?.VALOR ?? 0), classificacaoRisco: paciente.NOMECOR, tipoExame: paciente.TIPO, situacaoAtendimento: paciente.SITUACAO, situacaoMedicacao: paciente.AGUARDANDO, tipoPaciente: 'adulto' }));
		});

		let arrCoresInfantil = [];
		pacientesInfantil.forEach(paciente => {
			arrCoresInfantil.push(buscarCorSLA({ tipoCard: card.tipo, tempo: (paciente?.VALOR ?? 0), classificacaoRisco: paciente.NOMECOR, tipoExame: paciente.TIPO, situacaoAtendimento: paciente.SITUACAO, situacaoMedicacao: paciente.AGUARDANDO, tipoPaciente: 'infantil' }));
		});

		let corAdulto = 'VERDE';
		if (arrCoresAdulto.includes('VERMELHO')) {
			corAdulto = 'VERMELHO';
		} else if (arrCoresAdulto.includes('AMARELO')) {
			corAdulto = 'AMARELO';
		}

		let corInfantil = 'VERDE';
		if (arrCoresInfantil.includes('VERMELHO')) {
			corInfantil = 'VERMELHO';
		} else if (arrCoresInfantil.includes('AMARELO')) {
			corInfantil = 'AMARELO';
		}

		let pacienteMaiorTempo = {};
		let pacienteMaiorTempoTriagem = {};
		let pacienteMaiorTempoDispensacao = {};
		let pacienteMaiorTempoChecagem = {};
		let pacienteMaiorTempoColeta = {};
		let pacienteMaiorTempoLaudo = {};
		let pacienteMaiorTempoAutorizacao = {};
		let pacienteMaiorTempoLeitoExtra = {};

		if (dataPacientes.length >= 1) {
			pacienteMaiorTempo = dataPacientes.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);

			pacienteMaiorTempoTriagem = dataPacientes.reduce(
				(a, b) => Number(a.VALORTRIAGEM) > Number(b.VALORTRIAGEM) ? a : b
			);
		}

		if (pacientesDispensacao.length >= 1) {
			pacienteMaiorTempoDispensacao = pacientesDispensacao.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesChecagem.length >= 1) {
			pacienteMaiorTempoChecagem = pacientesChecagem.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesColeta.length >= 1) {
			pacienteMaiorTempoColeta = pacientesColeta.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesLaudo.length >= 1) {
			pacienteMaiorTempoLaudo = pacientesLaudo.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesAutorizacao.length >= 1) {
			pacienteMaiorTempoAutorizacao = pacientesAutorizacao.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		if (pacientesLeitoExtra.length >= 1) {
			pacienteMaiorTempoLeitoExtra = pacientesLeitoExtra.reduce(
				(a, b) => Number(a.VALOR) > Number(b.VALOR) ? a : b
			);
		}

		const maiorTempo = pacienteMaiorTempo?.VALOR ?? 0;
		const maiorTempoTriagem = pacienteMaiorTempoTriagem?.VALORTRIAGEM ?? 0;
		const maiorTempoDispensacao = pacienteMaiorTempoDispensacao?.VALOR ?? 0;
		const maiorTempoChecagem = pacienteMaiorTempoChecagem?.VALOR ?? 0;
		const maiorTempoColeta = pacienteMaiorTempoColeta?.VALOR ?? 0;
		const maiorTempoLaudo = pacienteMaiorTempoLaudo?.VALOR ?? 0;
		const maiorTempoAutorizacao = pacienteMaiorTempoAutorizacao?.VALOR ?? 0;
		const maiorTempoLeitoExtra = pacienteMaiorTempoLeitoExtra?.VALOR ?? 0;

		const tipoPacienteMaiorTempo = card.regras.isPediatria(pacienteMaiorTempo) ? 'infantil' : 'adulto';

		infoCards[card.tipo] = {
			totalPacientes: dataPacientes.length,
			totalAdulto: pacientesAdulto.length,
			totalInfantil: pacientesInfantil.length,
			totalDispensacao: pacientesDispensacao.length,
			totalChecagem: pacientesChecagem.length,
			totalColeta: pacientesColeta.length,
			totalLaudo: pacientesLaudo.length,
			totalAutorizacao: pacientesAutorizacao.length,
			totalLeitoExtra: pacientesLeitoExtra.length,

			maiorTempo: formatarTempo(maiorTempo),
			maiorTempoTriagem: formatarTempo(maiorTempoTriagem),
			maiorTempoDispensacao: formatarTempo(maiorTempoDispensacao),
			maiorTempoChecagem: formatarTempo(maiorTempoChecagem),
			maiorTempoColeta: formatarTempo(maiorTempoColeta),
			maiorTempoLaudo: formatarTempo(maiorTempoLaudo),
			maiorTempoAutorizacao: formatarTempo(maiorTempoAutorizacao),
			maiorTempoLeitoExtra: formatarTempo(maiorTempoLeitoExtra),

			corAdulto: corAdulto,
			corInfantil: corInfantil,

			corMaiorTempo: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempo,
				classificacaoRisco: pacienteMaiorTempo.NOMECOR,
				tipoExame: pacienteMaiorTempo.TIPO,
				situacaoAtendimento: pacienteMaiorTempo.SITUACAO,
				situacaoMedicacao: pacienteMaiorTempo.AGUARDANDO,
				tipoPaciente: tipoPacienteMaiorTempo,
			}),

			corMaiorTempoTriagem: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoTriagem,
				situacaoAtendimento: pacienteMaiorTempo.SITUACAO,
			}),

			corMaiorTempoDispensacao: buscarCorSLA({
				tipoCard: card.tipo,
				situacaoMedicacao: pacienteMaiorTempoDispensacao.AGUARDANDO,
				tempo: maiorTempoDispensacao,
			}),

			corMaiorTempoChecagem: buscarCorSLA({
				tipoCard: card.tipo,
				situacaoMedicacao: pacienteMaiorTempoChecagem.AGUARDANDO,
				tempo: maiorTempoChecagem,
			}),

			corMaiorTempoColeta: buscarCorSLA({
				tipoCard: card.tipo,
				tipoExame: pacienteMaiorTempoColeta.TIPO,
				classificacaoRisco: pacienteMaiorTempoColeta.NOMECOR,
				tempo: maiorTempoColeta,
			}),

			corMaiorTempoLaudo: buscarCorSLA({
				tipoCard: card.tipo,
				tipoExame: pacienteMaiorTempoLaudo.TIPO,
				classificacaoRisco: pacienteMaiorTempoLaudo.NOMECOR,
				tempo: maiorTempoLaudo,
			}),

			corMaiorTempoAutorizacao: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoAutorizacao,
			}),

			corMaiorTempoLeitoExtra: buscarCorSLA({
				tipoCard: card.tipo,
				tempo: maiorTempoLeitoExtra,
			}),
		};
	})

	return infoCards;
};

const derivarSituacao = (tipoCard, paciente) => {
	switch (Number(tipoCard)) {
		case 1: // Triagem
			if (paciente.SITUACAO === 'Aguardando Atendimento') return 'Aguard. Atendimento';
			return paciente.SITUACAO ?? null;
		case 2: // Cadastro
			if (paciente.SITUACAO === 'Aguardando Atendimento') return 'Aguard. Atendimento';
			return paciente.SITUACAO ?? null;
		case 3: // Atendimento Médico
			return paciente.AGUARDANDO ?? null;
		case 4: // Reavaliação Médica
			return null;
		case 5: // Medicação
			return paciente.AGUARDANDO ?? null;
		case 6: // Exames Laboratoriais
			return paciente.TIPO === 'COLETA' ? 'Coleta' : 'Laudo';
		case 7: // Exames de Imagem
			return paciente.TIPO === 'COLETA' ? 'Exame' : 'Laudo';
		case 8: // Internação
			if (paciente.SITUACAO === 'Aguardando Internação') return 'Aguard. Internação';
			if (paciente.SITUACAO === 'Aguardando Autorização') return 'Aguard. Autorização';
			return paciente.SITUACAO ?? null;
		default:
			return paciente.AGUARDANDO ?? paciente.SITUACAO ?? null;
	}
};

/**
 * Monta as informações consolidadas dos cards para a TELA PACIENTES.
 */
export const montarDadosPacientes = (dataDetalhada) => {
	const dadosPacientes = {};

	Object.entries(dataDetalhada).forEach(([index, lista]) => {
		lista.forEach(paciente => {
			const codigoPaciente = paciente?.CODIGOPACIENTE ?? '';
			const codigoAtendimento = paciente?.CODIGOATENDIMENTO ?? '';
			const nomePaciente = paciente?.NOMEPACIENTE ?? '';
			const corPulseira = paciente?.NOMECOR ?? '';
			const nomeSolicitante = paciente?.NOMESOLICITANTE ?? '';
			const especialidade = paciente?.DESCRICAOESPECIALIDADE ?? '';

			if (!codigoPaciente) return;

			// dados gerais
			if (!dadosPacientes[codigoPaciente]) {
				dadosPacientes[codigoPaciente] = {
					CODIGOPACIENTE: codigoPaciente,
					CODIGOATENDIMENTO: codigoAtendimento,
					NOMEPACIENTE: nomePaciente,
					NOMECOR: corPulseira,
					NOMESOLICITANTE: nomeSolicitante,
					DESCRICAOESPECIALIDADE: especialidade,
					LABELPROTOCOLO: cardProtocolo(paciente?.DOCUMENTOCLINICO),
					LABELCATEGORIA: cardCategoriaPaciente(paciente?.CATEGORIAPACIENTE),
					PROCESSOS: new Set()
				};
			}

			// dados dos processos
			const cardProcesso = CardsList.find(card => card.tipo == index);
			if (cardProcesso) {
				dadosPacientes[codigoPaciente].PROCESSOS.add({
					PROCESSO: cardProcesso.title,
					AGUARDANDO: derivarSituacao(index, paciente),
					ESPERA: paciente.VALOR,
					ESPERATOTAL: paciente.VALORTRIAGEM,
					COR: buscarCorSLA({
						tipoCard: index,
						tempo: paciente.VALOR,
						classificacaoRisco: corPulseira,
						tipoExame: paciente.TIPO,
						situacaoAtendimento: paciente.SITUACAO,
						situacaoMedicacao: paciente.AGUARDANDO,
						tipoPaciente: cardProcesso.regras.isPediatria(paciente) ? 'infantil' : 'adulto',
					}),
				});
			}
		});
	});

	return Object.values(dadosPacientes).map(item => ({
		...item,
		PROCESSOS: Array.from(item.PROCESSOS)
	}));
};
